module.exports = "../media/8db7d89833feeb71bacd9ba287f219de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/student.png
// module id = 519
// module chunks = 0